<template>
  <b-modal id="login-modal" title="Login" size="lg" centered>
    <div v-if="loggedUser==null">
      <div class="form-group">
        <label for="email-save-input">Your email:</label>
        <input
          class="form-control"
          type="email"
          v-model="loginEmailInput"
          name="email-save-input"
          id="email-save-input"
        />
      </div>

      <div class="form-group">
        <label for="delaer-input">Password:</label>
        <input
          class="form-control"
          type="password"
          v-model="loginPasswordInput"
          name="password-save-input"
          id="password-save-input"
        />
      </div>
    </div>
    <div v-else>
      Welcome, {{loggedUser.first_name}}
    </div>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="secondary"
          size="sm"
          class="float-right"
          @click="$root.$emit('bv::hide::modal', 'login-modal')"
        >
          Close
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          class="float-right mr-1"
          v-if="loggedUser==null"
          @click="login()"
        >
          Login
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  name: "save-modal",
  props: ["loginEmail", "loginPassword", "loggedUser"],
  data() {
    return {
      download_pdf: false,
      dealer: null,
      dealers: [{ text: "Passoni", value: 1 }],
    };
  },
  mounted() {
    let t = this;
    axios
      .get("/api/mtm-configurator/dealers")
      .then((res) => {
        this.dealers = res.data;
      })
      .catch(function (error) {
        if (error.response) {
          t.$emit("set-error", "Cannot load dealers");
        }
      });
  },
  computed: {
    loginEmailInput: {
      get: function () {
        return this.loginEmail;
      },
      set: function (e) {
        this.$emit("set-login-email", e);
      },
    },
    loginPasswordInput: {
      get: function () {
        return this.loginPassword;
      },
      set: function (e) {
        this.$emit("set-login-password", e);
      },
    },
  },
  methods: {
    login: function () {
      if (this.loginEmail == "" || this.loginEmail == null) {
        this.$emit("set-error", "Please compile email");
        return false;
      }
      if (this.loginPassword == "" || this.loginPassword == null) {
        this.$emit("set-error", "Please compile password");
        return false;
      }
      this.$emit("login");
    },
  },
};
</script>
